import { DialogStackProvider as BuiDialogStackProvider, DialogStackContext } from '@paintscout/ui'
import React, { useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

function DialogStackProviderWithRouter(props: { children: any }) {
  return (
    <BuiDialogStackProvider {...props}>
      <DialogDismisser />
      {props.children}
    </BuiDialogStackProvider>
  )
}

// dismisses dialogs on route change
function DialogDismisser(): JSX.Element {
  const { dismissAllDialogs, stack } = useContext(DialogStackContext)

  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const dialogsExist = stack.length > 0

    if (history.action !== 'REPLACE' && dialogsExist) {
      dismissAllDialogs()
    }
  }, [location])

  return null
}
export default DialogStackProviderWithRouter
